module.exports = __webpack_public_path__ + "public/StoreIcon/docUpload.svg?d6b298e5";